import baseAxios from 'axios';
import { useNotification } from '@/shared/hooks/useNotification';
import { endPoints } from '@/shared/types/api';

const axios = baseAxios.create({
  baseURL: '/api',
  withCredentials: true,
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  // エラーの場合
  async (error) => {
    const { showNotification } = useNotification();

    const message = error?.response?.data?.message;
    if (error.config.url === endPoints.saveResultPublicationDocument.endPoint)
      return Promise.reject(message);

    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type?.toLowerCase().indexOf('json') != -1
    ) {
      const parsedMessage = JSON.parse(
        await error.response.data.text(),
      ).message;

      showNotification({
        message: parsedMessage,
        type: 'error',
        isShow: true,
      });
      return Promise.reject(parsedMessage);
    } else {
      showNotification({
        message,
        type: 'error',
        isShow: true,
      });

      return Promise.reject(message);
    }
  },
);
export { axios };
